<template>
  <customer-layout>
    <div v-if="client.iprofile_token != null" class="pt-6 pb-12">
    <Delivery
      :client="client"
      :plus="plus"
      :whynot="whynot"
      :sindrome="sindrome"
      :soft="soft"
      :minus="minus"
      :badnumber="badnumber"
      :gems="gems"
      :lowprofile="lowprofile"
      :highprofile="highprofile"
      :excellence="excellence"
      :allgood="allgood"
      :firstdiamonds="firstdiamonds"
      :survey="survey"
      :yourbest="yourbest"
      :lower="lower"
    ></Delivery>
    </div>
    <div v-else class="flex flex-col items-center content-center justify-center h-screen pt-6 pb-12 bg-gray-800">
        <img src="/img/icon-qrcode.svg" alt="gem" class="w-4/12 my-2" />
        <h4 class="px-8 py-1 text-xl text-center text-white">{{ $t('You have not yet uploaded the I-Profile questionnaire') }}</h4>
        <inertia-link :href="route('qrcode.create')" class="px-6 py-2 mx-4 my-4 text-center text-white bg-pink-600 rounded-xl">{{ $t('It begins now') }}</inertia-link>

        <h4 class="px-8 py-1 mt-4 text-center text-white">{{ $t("Don't have the I-Profile questionnaire?") }}</h4>
        <a href="https://docs.google.com/forms/d/1tliF3LoW4eCZn0rOZCMxxTcdnqMW8FCSZ8Sr977ymoQ/edit?ts=60c74cbe" target="blank" class="px-6 py-2 mx-4 my-4 text-center text-white bg-blue-600 rounded-xl">{{ $t('Request it') }}</a>
    </div>
  </customer-layout>
</template>

<script>
import Delivery from "@/Components/Delivery";
import CustomerLayout from '../../Layouts/CustomerLayout.vue';

export default {
  components: {
    Delivery,
    CustomerLayout
  },
  props: [
    "client",
    "plus",
    "whynot",
    "sindrome",
    "minus",
    "badnumber",
    "gems",
    "excellence",
    "allgood",
    "firstdiamonds",
    "soft",
    "survey",
    "lowprofile",
    "highprofile",
    "yourbest",
    "lower"
  ],
};
</script>